import {config as riskNameConfigFs} from './RegionComponentTeamRiskName';
import {config as detailsConfig} from './Details';
import {config as checkboxConfig} from './CustomCheckbox';
import {config as addedConfig} from './Added';

export default (labels, handleChange) => [
	checkboxConfig(handleChange),
	riskNameConfigFs(labels),
	detailsConfig(labels),
	addedConfig()
];
